import React, { useState } from 'react'
import { Dialog, MenuItem, MenuList, Typography } from '@mui/material';
import { SendToMobile as SendToMobileIcon, Share as ShareIcon } from '@mui/icons-material';
import ShareWithConnectionDialog from './ShareWithConnectionDialog';

function ShareDialog({
  post,
  open = false,
  onClose,
}) {
  const [openConnectionDialog, setOpenConnectionDialog] = useState(false);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const shareExternally = () => {
    const base = process.env.REACT_APP_BASE_URL ?? 'http://localhost:3000';
    // If this is an event, prefer sharing the event route so opening the link loads the event view
    const isEvent =
      post?.isEvent ||
      post?.startTime ||
      post?.endTime ||
      post?.eventType ||
      post?.attendeesFrom ||
      post?.admissionFeeType ||
      (typeof post?.id === 'string' && post.id.startsWith('event-'));
    console.log('post: ', post);

    const content = isEvent
      ? `${base}/event/${String(post.id).replace('event-', '')}`
      : `${base}/post/${post?.id}`;

    if (navigator.share) {
      navigator.share({
        title: content,
        url: content,
      });
    }
  }

  const shareInternally = () => {
    setOpenConnectionDialog(true);
  }

  // Greater than 1 because poster themselves are a connection by default
  const postWasOnlySharedWithConnections = post?.connections?.length > 1 && !post.communities?.length && !post.groups?.length;
  // External share disabled only when ALL groups are private
  const allGroupsPrivate = Boolean(
    post?.groups &&
    Array.isArray(post.groups) &&
    post.groups.length > 0 &&
    post.groups.every((g) => String(g?.visibility || "").toLowerCase() === "private"),
  );

  const shareExternallyDisabled = !isMobile || allGroupsPrivate || postWasOnlySharedWithConnections;
  const shareInternallyDisabled = postWasOnlySharedWithConnections;

  if(!shareInternallyDisabled && shareExternallyDisabled)
    return (
      <ShareWithConnectionDialog
        post={post}
        open={open}
        onClose={onClose}
        onSuccess={onClose}
      />
    )

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "rounded-xl",
      }}
    >
      <MenuList>
        {/* Hide external share entirely when all groups are private */}
        {!allGroupsPrivate && (
          <MenuItem
            onClick={shareExternally}
            disabled={shareExternallyDisabled}
          >
            <SendToMobileIcon className="mr-2" color="primary" />

            <Typography className="text-sm">Share externally</Typography>
          </MenuItem>
        )}
        <MenuItem onClick={shareInternally} disabled={shareInternallyDisabled}>
          <ShareIcon className="mr-2" color="primary" />

          <Typography className="">Share internally</Typography>
        </MenuItem>
      </MenuList>

      <ShareWithConnectionDialog
        post={post}
        open={openConnectionDialog}
        onClose={() => setOpenConnectionDialog(false)}
        onSuccess={onClose}
      />
    </Dialog>
  );
}

export default ShareDialog;